import { Invoices } from 'Features/Invoices';
import { Permission } from 'Models/Templates/Permission/Permission';
import { DropdownSubRouteConfig, SubRoutes } from 'Navigation';
import React from 'react';
import { InvoicesPage } from 'v3/Components/Pages/Invoices/Invoices';

export enum ReportsSubRoute {
  Invoices = '/Invoices',
  CaseReporting = '/CaseReporting',
}

// FeatureFlags enum is unavailable at module init due to a circular dependency through
// FeatureFlagProvider → Components/Navigation → Navigation → SubRoutesMap → here.
// readFeatureFlag bypasses that cycle by reading window/process.env directly.
const v3InvoicesEnabled = (() => {
  const windowVal = (window as Record<string, any>)['V3_INVOICES'];
  if (windowVal != null && !String(windowVal).startsWith('#{')) {
    return String(windowVal).toLowerCase() === 'true';
  }
  return process.env.REACT_APP_V3_INVOICES === 'true';
})();
const activeRoute = v3InvoicesEnabled ? ReportsSubRoute.CaseReporting : ReportsSubRoute.Invoices;

const InvoicesRoute = React.forwardRef<any, any>((props, _ref) =>
  v3InvoicesEnabled
    ? <InvoicesPage {...props} />
    : <Invoices {...props} />
);

export const ReportsSubRoutes: SubRoutes = {
  [activeRoute]: new DropdownSubRouteConfig(
    activeRoute,
    v3InvoicesEnabled ? 'Case Reporting' : 'Invoices',
    InvoicesRoute,
    [Permission.ViewInvoices],
    true,
    {}
  ),
};
